import { Component, Vue } from 'vue-property-decorator';
import { format } from 'date-fns';
import { pickBy as _pickBy } from 'lodash';

import DetailInventoryService from '@/services/inventories_detail';
import SkuService from '@/services/skus';

@Component({

})
export default class DetailInventory extends Vue {
  public detailInventoryService = new DetailInventoryService();
  public skuService = new SkuService();

  public isLoading = false;
  public isLoadingSku = false;

  public detailInventories: any[] = [];
  public supplier_name = '';
  public sku = '';

  public async mounted() {
    this.supplier_name = this.$route.params.supplier_name;
    this.sku = this.$route.params.sku;

    await this.fetchDetail();
  }

  public async fetchDetail() {
    this.isLoading = true;

    try {
      const retrived = await this.detailInventoryService.detail(this.supplier_name, this.sku);
      this.detailInventories = retrived.inventory;
      const skus = this.detailInventories.map((detail: any) => {
        return detail.sku;
      })
      await this.fetchSku(skus);
    } catch(e) {
      console.log("Error: "+e);
    } finally {
      this.isLoading = false;
    };
  }

  public async fetchSku(skus: any) {
    this.isLoadingSku = true;

    try {
      const retrivedSku: any = await this.skuService.index({skus: skus});

      this.detailInventories.forEach((detailInventory: any) => {
        retrivedSku.skus.forEach((sku: any) => {
          detailInventory['variant_name'] = sku.variant_name;
        });
      });
    } catch(e) {
      console.log("Error: "+e);
    } finally {
      this.isLoadingSku = false;
    }
  }
}


